import React, { useEffect, useState } from "react";
import {
  Box,
  Text,
  TableBody,
  Table,
  TableCell,
  TableHeader,
  TableRow,
  Button,
} from "grommet";
import axios from "axios";
import API_URL from "../../config/config";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { getProductSkills } from "../../services/getProductSkills";

// Register the required components with ChartJS
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);

export const ProductsAssessment = ({
  user_id,
  assessment_id,
  onShowLearningPath,
}) => {
  const [productsToWorkOn, setProductsToWorkOn] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      getProductSkills({ user_id, assessment_id })
        .then((response) => {
          setProductsToWorkOn(response.data.subProducts);
        })
        .catch((error) => {
          console.error("Error fetching products to work on:", error);
        });
    };

    fetchData();
  }, [user_id]);

  // Prepare data for the bar chart
  const skillLabels = productsToWorkOn.map(
    (item) => `${item.product_name} - ${item.skill_name}`,
  );
  const skillCounts = productsToWorkOn.map((item) => item.count);

  const data = {
    labels: skillLabels,
    datasets: [
      {
        label: "Number of Lacking Questions",
        data: skillCounts,
        backgroundColor: "rgba(53, 162, 235, 0.5)",
      },
    ],
  };

  const options = {
    indexAxis: "y", // Display bars horizontally
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "Skills Needing Improvement",
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        ticks: {
          precision: 0,
        },
      },
    },
  };

  return (
    <Box
      direction="column"
      gap="medium"
      pad="small"
      alignContent="center"
      align="center"
      justify="between"
    >
      {/* {productsToWorkOn.length > 0 && (
        <Box width="large" height="medium">
          <Bar data={data} options={options} />
        </Box>
      )} */}
      <Box>
        <Text size="large" weight="bold" margin={{ bottom: "medium" }}>
          Skills assessed on
        </Text>
        {productsToWorkOn.length === 0 ? (
          <Text>
            Based on the skills that you have selected and your responses,
            there are currently no recommended courses. You can try a new
            self-assessment with a new set of skills.
            <br />
            We recommend <b>HPE Digital Learner</b> to keep your skills
            refreshed and learn further skills 24/7x365 days.
          </Text>
        ) : (
          <Box width="large" pad="small">
            <Table pad="medium">
              <TableHeader>
                <TableRow>
                  <TableCell scope="col">
                    <Text size="medium" weight="bold">
                      Product name
                    </Text>
                  </TableCell>
                  <TableCell scope="col">
                    <Text size="medium" weight="bold">
                      Skill name
                    </Text>
                  </TableCell>
                  <TableCell scope="col">
                    <Text size="medium" weight="bold">
                      Course recommendation
                    </Text>
                  </TableCell>
                </TableRow>
              </TableHeader>
              <TableBody>
                {productsToWorkOn.map((item) => (
                  <TableRow key={item.id}>
                    <TableCell>
                      <Text size="medium">{item.product_name}</Text>
                    </TableCell>
                    <TableCell>
                      <Text size="medium">{item.skill_name}</Text>
                    </TableCell>
                    <TableCell>
                      <Button
                        style={{ margin: "small" }}
                        primary
                        label="View"
                        onClick={() => onShowLearningPath(item.id)} // Pass `skills_id` here
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        )}
      </Box>
    </Box>
  );
};
